<template>
  <tr
    class="rounded-md !shadow-lg cursor-pointer px-2 h-fit"
    :class="{
      'bg-gray-200 min-h-28': selected,
      'bg-white': !selected && index % 2 == 0,
      'bg-gray-100': !selected && index % 2 != 0,
    }"
    @click="onClickSelected">
    <td class="w-fit max-w-40 pt-0 pr-2">{{ eventDateDisplay }}</td>
    <td class="w-fit max-w-40 pt-0 pr-2">{{ event.district ? event.district.label : 'N/A' }}</td>
    <td class="w-fit max-w-40 pt-0 pr-2">{{ gradeFormatter(event.low_grade, event.high_grade) }}</td>
    <td class="w-fit max-w-40 pt-0 pr-2">{{ typeFormatter(event.event_type) }}</td>
    <td class="w-fit max-w-40 pt-0 pr-2">{{ timeOrTimeDifference }}</td>
    <td class="w-fit max-w-40 pt-0 pr-2">{{ truncateString(event.building?.name) }}</td>
    <td class="w-fit max-w-40 pt-0 pr-2">{{ truncateString(event.notes) }}</td>
    <td class="w-fit max-w-40 pt-0 pr-2">{{ submissionDateDisplay }}</td>
    <div class="flex flex-column">
      <Button 
        type="button"
        color="gray"
        size="sm"
        class="rounded-md !shadow m-1"
        @click="onEdit()"
      >
        Edit
      </Button>
      <Button
        type="button"
        color="gray"
        size="sm"
        class="rounded-md !shadow m-1"
        @click="onDelete()"
      >
        Delete
      </Button>
    </div>
  </tr>
</template>

<script>
import Button from '../../components/Button.vue'
import DropdownLists from "../../components/DropdownLists.json"

export default {
  components: {
    Button,
  },
  props: {
    event: Object,
    selected: Boolean,
    index: Number,
  },
  data() {
    return {
      open: false,
      directions: {
        I: 'Inbound',
        O: 'Outbound',
        B: 'Both',
      },
    }
  },
  methods: {
    dateFormatter(value) {
      let date = new Date(value)
      return date.toDateString()
    },
    dateTimeFormatter(value) {
      let date = new Date(value)
      return `${date.toDateString()},\n ${date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`
    },
    truncateString(value) {
      if (value) {
        if (this.selected) {
          return value
        }
        return value?.slice(0, 20) + (value?.length > 20 ? '...' : '')
      }
      else {
        return ''
      }
    },
    gradeFormatter(lowGrade, highGrade) {
      let low = DropdownLists.gradeList[lowGrade] ? DropdownLists.gradeList[lowGrade] : 'Pre-K'
      let high = DropdownLists.gradeList[highGrade] ? DropdownLists.gradeList[highGrade] : '12+'
      return low + ' - ' + high
    },
    typeFormatter (value) {
      return value.includes('undefined') ?  '' : DropdownLists.eventList[value]
    },
    formatTime(initTime) {
      var HH = initTime.substring(0, 2)
      var MM = initTime.substring(3, 5)
      let ampm = "AM"
      if (Number(HH) > 12) {
        HH = Number(HH) - 12
        ampm = "PM"
      }
      else if (Number(HH) == 12) {
        ampm = "PM"
      }
      else if (Number(HH) == 0) {
        HH = 12
      }
      return HH + ':' + MM + ' ' + ampm  
    },
    onEdit() {
      this.$emit('onEdit')
    },
    onDelete() {
      this.$emit('onDelete')
    },
    onClickSelected() {
      this.$emit('changeSelected', this.event.id)

      // do something
    },
  },
  computed: {
    timeOrTimeDifference() {
      let event = this.event
      if (event.time) {
        return this.formatTime(event.time)
      }
      else if (event.time_difference) {
        let hours = Math.floor(event.time_difference / 60)
        let minutes = event.time_difference % 60
        let str = ''
        if (hours > 0) {
          str += `${hours} HR `
        }
        if (minutes > 0) {
          str += `${minutes} MIN`
        }
        return str
      }
      else {
        return ''
      }
    },
    submissionDateDisplay() {
      if (!this.event.created_at) return ''

      return new Date(this.event.created_at).toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
    eventDateDisplay() {
      if (!this.event.event_date) return ''

      return new Date(this.event.event_date).toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timeZone: 'UTC',
      })
    },
  },
  async created() {
    // do nothing
  },
}
</script>
